import { trackTileClick } from '../events'
import { AnnouncementTile } from './AnnouncementTile'
import { ClassTile } from './ClassTile'
import { GlobalCarouselTileProps } from './types'

export const GlobalCarouselTile = ({
  tile,
  carouselSlug,
  location,
  onClick = trackTileClick,
  openNewPage = false,
  onClickWatchTrailer,
  isPrioritized = false,
  clickBehavior,
  trackProps,
}: GlobalCarouselTileProps) => {
  // if it has a backgroundImage, it's an announcement tile
  const isAnnouncementTile = tile.backgroundImage

  return (
    <div className='col'>
      {isAnnouncementTile ? (
        <AnnouncementTile
          tile={tile}
          carouselSlug={carouselSlug}
          location={location}
          onClick={onClick}
          openNewPage={openNewPage}
          isPrioritized={isPrioritized}
        />
      ) : (
        <ClassTile
          tile={tile}
          carouselSlug={carouselSlug}
          location={location}
          onClick={onClick}
          openNewPage={openNewPage}
          isPrioritized={isPrioritized}
          onClickWatchTrailer={onClickWatchTrailer}
          clickBehavior={clickBehavior}
          trackProps={trackProps}
        />
      )}
    </div>
  )
}
